import React from 'react'
import { Box, Typography } from '@mui/material'

interface DetailsPaneItemProps {
  header: string
  content: string | JSX.Element
  textColor?: string
}
export const DetailsPaneItem = (props: DetailsPaneItemProps) => {
  const { header, content, textColor } = props

  return (
    <Box>
      <Typography
        sx={{
          marginLeft: '0px',
          fontWeight: '500',
          color: '#253140',
          fontSize: '14px'
        }}
      >
        {header}
      </Typography>
      {typeof content === 'string' ? (
        <Typography
          sx={{
            marginLeft: '0px',
            fontWeight: '400',
            color: textColor ? textColor : '#818D9C',
            fontSize: '16px'
          }}
        >
          {content}
        </Typography>
      ) : (
        <Box>{content}</Box>
      )}
    </Box>
  )
}
